export const common = {
  // Navigation
  nav_home: 'Home',
  nav_about: 'About',
  nav_portfolio: 'Works',
  nav_gallery: 'Gallery',
  nav_products: 'Products',
  nav_testimonials: 'Testimonials',
  nav_process: 'Process',
  nav_pricing: 'Pricing',
  nav_faq: 'FAQ',
  nav_contact: 'Contact',

  // Hero Section
  hero_title: 'High-Quality Laser Engraving for',
  hero_subtitle: 'Eternal Special Moments',
  hero_title_line1: 'High-Quality',
  hero_title_line2: 'Laser Engraving for',
  hero_title_line3: 'Eternal Special Moments',
  hero_description:
    'From stainless steel memorial plates to luxury metal business cards and custom commemorative items. With professional laser engraving technology, we beautifully engrave your precious memories and important moments.',
  hero_cta: 'Start Free Consultation',
  hero_secondary_cta: 'View Portfolio',

  // About Section
  about_title: 'About the Creator',
  about_subtitle: 'Fusion of Passion and Creativity',
  about_title_default: 'About NEXUTHA',
  about_subtitle_default: 'Shaping Your Thoughts with Precision Laser Engraving',
  about_description_default: 'We use the latest laser engraving technology to help you preserve your precious memories and special moments in a beautiful, lasting form.',
  about_description:
    'Fascinated by the world of laser engraving, I dedicate myself to daily skill improvement. Using the Xtool F1 Ultra, I carefully bring your thoughts to life. As a startup, I pour passion into every single piece I create.',
  about_experience: '2 Years Experience',
  about_projects: 'Completed Projects',
  about_satisfaction: 'Customer Satisfaction',
  about_feature_precision_title: 'Xtool F1 Ultra Used',
  about_feature_precision_desc:
    'Using the latest Xtool F1 Ultra laser equipment to achieve precise and beautiful engraving.',
  about_feature_design_title: 'Original Design',
  about_feature_design_desc:
    'Creating unique designs with specialized line art illustrations using Procreate.',
  about_feature_service_title: 'Careful Personal Service',
  about_feature_service_desc:
    'As a startup, we cherish heartfelt, personalized service for each and every customer.',
  about_years_experience: '2 Years of Experience',
  about_image_alt: 'Young craftsman working on laser engraving',

  // Portfolio Section
  portfolio_title: 'Portfolio',
  portfolio_subtitle: 'View our previous work',
  portfolio_all: 'All',
  portfolio_plates: 'Stainless Memorial Plates',
  portfolio_cards: 'Luxury Metal Cards',
  portfolio_custom: 'Custom Items',
  portfolio_view_details: 'View Details',
  portfolio_item_memorial_plate: 'Stainless Memorial Plate',
  portfolio_item_memorial_plate_desc:
    'Permanent memorial plate using high-quality stainless steel materials',
  portfolio_item_metal_card: 'Luxury Metal Business Card',
  portfolio_item_metal_card_desc:
    'Impressive luxury metal business cards for professional settings',
  portfolio_item_custom_accessory: 'Custom Business Card',
  portfolio_item_custom_accessory_desc:
    'Original accessories tailored to customer requirements',
  portfolio_item_nameplate: 'Walnut Nameplate',
  portfolio_item_nameplate_desc:
    'Nameplate combining the beauty of natural wood with precision laser engraving',
  portfolio_item_leather_keychain: 'Leather Keychain',
  portfolio_item_leather_keychain_desc:
    'High-quality leather keychain with precision laser engraving',
  portfolio_item_acrylic_keychain: 'Acrylic Keychain (Black Limited)',
  portfolio_item_acrylic_keychain_desc:
    'High-quality keychain with precision laser engraving on black limited acrylic material',
  portfolio_leather_keychain_title: 'Leather Keychain',
  portfolio_leather_keychain_desc:
    'Premium quality leather keychain with exceptional durability',
  portfolio_acrylic_keychain_title: 'Acrylic Keychain',
  portfolio_acrylic_keychain_desc:
    'Beautiful transparent acrylic custom keychain with modern design',
  portfolio_cta_text: 'Ready to bring your ideas to life?',
  portfolio_cta_button: 'Start Free Consultation',
  portfolio_completed_works: 'Completed Works',
  portfolio_satisfaction_rate: 'Satisfaction Rate',
  portfolio_years_experience: 'Years of Experience',
  portfolio_cta_main_text: 'Create Your Special Custom Piece?',
  portfolio_cta_description:
    'We create unique, one-of-a-kind original pieces tailored to your specific requirements',
  portfolio_cta_consultation: 'Free Consultation',
  portfolio_cta_phone: 'Call Us',
  portfolio_note_title: 'About Our Portfolio Photos',
  portfolio_note_desc: 'At NEXUTHA, we carefully engrave your precious memories one by one. Many of our works are original custom orders based on individual requests, and due to copyright and other considerations, we are unable to publish photos of all completed works. The images displayed include works from customers who have kindly agreed to share, along with reference images. We invite you to experience your very own special piece firsthand.',

  // Process Section
  process_title: 'Process',
  process_subtitle: '4 Steps to Bring Your Vision to Life',
  process_step1_title: 'Consultation & Quote',
  process_step1_desc:
    'We listen carefully to your requirements and propose the optimal plan.',
  process_step2_title: 'Design Creation',
  process_step2_desc:
    'Create laser engraving-specific line art illustrations using Procreate.',
  process_step3_title: 'Laser Engraving',
  process_step3_desc: 'Carefully engrave using the Xtool F1 Ultra.',
  process_step4_title: 'Completion & Delivery',
  process_step4_desc:
    'After quality check, we carefully deliver your finished product.',
  process_step: 'Step',
  process_timeline_title: 'Production Timeline',
  process_timeline_subtitle: 'Typical production schedule',
  process_timeline_consultation: 'Consultation',
  process_timeline_consultation_time: 'Same day',
  process_timeline_design: 'Design',
  process_timeline_design_time: '2-3 days',
  process_timeline_production: 'Production',
  process_timeline_production_time: '3-5 days',
  process_timeline_delivery: 'Delivery',
  process_timeline_delivery_time: '1-2 days',

  // Pricing Section
  pricing_title: 'Pricing Plans',
  pricing_subtitle: 'Clear pricing tailored to your needs',
  pricing_popular: 'Popular',
  pricing_price: '¥',
  pricing_from: 'from',
  pricing_per_piece: '/piece',
  pricing_contact_for_order: 'Contact for Order',
  pricing_web_discount: '10% discount for website inquiries',
  pricing_single_order: 'Order from 1 piece',
  pricing_best_value: 'Best Value',
  pricing_homepage_discount_banner: '🎉 10% OFF for website orders!',
  pricing_simulator_title: '💰 Price Simulator',
  pricing_product_type: 'Product Type',
  pricing_stainless_namecard: 'Stainless Steel Business Card',
  pricing_memorial_plate: 'Memorial Plate',
  pricing_size_label: 'Size (Max 22cm×22cm)',
  pricing_size_10x10: '10cm × 10cm - ¥8,000',
  pricing_size_15x15: '15cm × 15cm - ¥12,000',
  pricing_size_20x20: '20cm × 20cm - ¥16,000',
  pricing_size_22x22: '22cm × 22cm - ¥20,000',
  pricing_quantity_label: 'Quantity',
  pricing_quantity_1: '1 piece - ¥500',
  pricing_quantity_50: '50-piece set - ¥10,000',
  pricing_quantity_100: '100-piece set - ¥20,000',
  pricing_estimate_result: 'Estimate Result',
  pricing_base_price: 'Base Price',
  pricing_homepage_discount: 'Website Discount (10% OFF)',
  pricing_total_amount: 'Total Amount',
  pricing_view_testimonials: 'View Customer Reviews',
  pricing_professional_impression: 'Professional impression',
  pricing_single_order_available: 'Order from 1 piece',
  pricing_per_piece_price: 'per piece',
  pricing_50_piece_set: '50-piece set',
  pricing_100_piece_set: '100-piece set',
  pricing_regular_price: 'Regular ¥25,000',
  pricing_regular_price_100: 'Regular ¥50,000',
  pricing_special_moments: 'Eternal special moments',
  pricing_max_size: 'Max 22cm × 22cm',
  pricing_contact_info: 'Contact Information',
  pricing_phone_inquiry: 'Phone Inquiries',
  pricing_email_inquiry: 'Email Inquiries',

  // Stainless Steel Business Cards
  pricing_stainless_cards_title: 'Stainless Steel Business Cards',
  pricing_stainless_title: 'Single Order',
  pricing_stainless_description: 'Order from 1 piece',
  pricing_stainless_feature1: 'Premium stainless steel material',
  pricing_stainless_feature2: 'Precision laser engraving',
  pricing_stainless_feature3: 'Exceptional durability',
  pricing_10_pieces_set: '10-piece set',
  pricing_50_pieces_set: '50-piece set',
  pricing_100_pieces_set: '100-piece set',
  pricing_15_percent_off: '15% OFF',
  pricing_25_percent_off: '25% OFF',
  pricing_30_percent_off: '30% OFF',

  // Memorial Plates
  pricing_memorial_plates_title: 'Memorial Plates',
  pricing_memorial_small_desc: 'Small size memorial plate',
  pricing_memorial_large_desc: 'Large size memorial plate',
  pricing_memorial_feature1: 'Custom design support',
  pricing_memorial_feature2: 'Perfect for commemorative items',
  pricing_memorial_feature3: 'Lasting quality',

  // Custom Design
  pricing_custom_design_title: 'Custom Design Fee',
  pricing_custom_design_desc: 'Creation cost for original designs',
  pricing_custom_consultation: 'Design Consultation',

  // Size Limitation
  pricing_size_limitation_title: 'Available Production Size',
  pricing_size_limitation_desc:
    'We can produce up to a maximum of 22cm × 22cm',

  // Additional Services
  pricing_additional_title: 'Service Guarantee',
  pricing_web_discount_title: 'Website Discount',
  pricing_web_discount_desc: '10% OFF for website inquiries',
  pricing_guarantee_title: 'Quality Guarantee',
  pricing_guarantee_desc: '30-day quality guarantee',
  pricing_shipping_title: 'Free Shipping',
  pricing_shipping_desc: 'Nationwide free shipping',
  pricing_support_title: 'After-Sales Support',
  pricing_support_desc: 'Reliable support after production',

  // Pricing section
  'pricing.title': 'Pricing Plans',
  'pricing.subtitle':
    'We provide high-quality stainless steel processing with clear and transparent pricing.',

  // Pricing simulator
  'pricing.simulator.title': 'Price Simulator',
  'pricing.simulator.product_type': 'Select Product Type',
  'pricing.simulator.namecard.title': 'Stainless Steel Business Card',
  'pricing.simulator.namecard.description':
    'Premium stainless steel business cards',
  'pricing.simulator.namecard.price_from': '¥500~',
  'pricing.simulator.plate.title': 'Memorial Plate',
  'pricing.simulator.plate.description':
    'Perfect for special commemorative items',
  'pricing.simulator.plate.price_from': '¥3,000~',
  'pricing.simulator.size_select': 'Select Size',
  'pricing.simulator.quantity_select': 'Select Quantity',
  'pricing.simulator.pieces': 'pieces',
  'pricing.simulator.discount_off': 'OFF',
  'pricing.simulator.estimate_result': 'Estimate Result',
  'pricing.simulator.product_type_label': 'Product Type:',
  'pricing.simulator.size_label': 'Size:',
  'pricing.simulator.quantity_label': 'Quantity:',
  'pricing.simulator.website_discount': 'Website Discount (10% OFF):',
  'pricing.simulator.discount_applied': 'Applied',
  'pricing.simulator.tax_included': '(Tax Included)',
  'pricing.simulator.request_estimate':
    'Request Quote with This Selection',

  // Estimate modal
  'pricing.estimate.title': 'Request Quote',
  'pricing.estimate.selectedItems': 'Selected Items',
  'pricing.estimate.productType': 'Product Type',
  'pricing.estimate.size': 'Size',
  'pricing.estimate.quantity': 'Quantity',
  'pricing.estimate.pieces': 'pieces',
  'pricing.estimate.totalPrice': 'Total Price',
  'pricing.estimate.name': 'Name',
  'pricing.estimate.namePlaceholder': 'Please enter your name',
  'pricing.estimate.email': 'Email Address',
  'pricing.estimate.emailPlaceholder': 'Please enter your email address',
  'pricing.estimate.phone': 'Phone Number',
  'pricing.estimate.phonePlaceholder': 'Please enter your phone number',
  'pricing.estimate.designRequests': 'Design Requirements',
  'pricing.estimate.designPlaceholder':
    'Please let us know your design requirements or questions',
  'pricing.estimate.characters': 'characters',
  'pricing.estimate.cancel': 'Cancel',
  'pricing.estimate.submit': 'Send Quote Request',
  'pricing.estimate.success':
    'Quote request sent successfully. We will contact you within 24 hours.',
  'pricing.estimate.error': 'Failed to send. Please try again.',
  'pricing.estimate.network_error':
    'A transmission error occurred. Please try again.',
  'pricing.estimate.required_fields':
    'Name and email address are required fields.',

  // Pricing plans
  'pricing.namecard.title': 'Stainless Steel Business Cards',
  'pricing.namecard.feature1': 'Premium stainless steel material',
  'pricing.namecard.feature2': 'Laser engraving processing',
  'pricing.namecard.feature3': 'Exceptional durability',
  'pricing.plate.title': 'Memorial Plates',
  'pricing.plate.feature1': 'Custom design support',
  'pricing.plate.feature2': 'Perfect for commemorative items',
  'pricing.plate.feature3': 'Lasting quality',

  // Contact Section
  contact_title: 'Contact Us',
  contact_description:
    'Consultation and quotes for production are free. Please feel free to contact us.',
  contact_info_title: 'Feel Free to Contact Us',
  contact_info_description:
    'As a startup, we strive to provide heartfelt and careful service to each customer. Please feel free to contact us with any questions, consultations, or quote requests.',
  contact_info_email_title: 'Email',
  contact_info_email_desc: '24/7 reception, next business day response',
  contact_info_phone_title: 'Phone',
  contact_info_phone_desc: 'Available during business hours',
  contact_info_hours_title: 'Business Hours',
  contact_info_hours_content: '9:00 - 18:00',
  contact_info_hours_desc:
    'Monday-Saturday (Closed Sundays & Holidays)',
  contact_info_online_title: 'Online Only',
  contact_info_online_content: 'Nationwide Service',
  contact_info_online_desc: 'Online orders only',
  contact_form_title: 'Detailed Inquiry',
  contact_name: 'Name',
  contact_email: 'Email Address',
  contact_phone: 'Phone Number',
  contact_material: 'Preferred Material',
  contact_budget: 'Budget',
  contact_category: 'Production Category',
  contact_deadline: 'Preferred Deadline',
  contact_details: 'Detailed Requirements & Questions',
  contact_details_placeholder:
    'Please tell us about the item you want to create, design preferences, and any other questions (within 500 characters)',
  contact_character_count: ' characters',
  contact_submit: 'Send Inquiry',
  contact_submitting: 'Sending...',
  contact_select_option: 'Please select',
  contact_material_walnut: 'Walnut Wood',
  contact_material_oak: 'Oak Wood',
  contact_material_stainless: 'Stainless Steel',
  contact_material_other: 'Other/Consultation',
  contact_budget_under_10k: 'Under ¥10,000',
  contact_budget_10k_20k: '¥10,000 - ¥20,000',
  contact_budget_20k_50k: '¥20,000 - ¥50,000',
  contact_budget_over_50k: 'Over ¥50,000',
  contact_budget_consultation: 'Consultation required',
  contact_category_nameplate: 'Nameplate',
  contact_category_memorial: 'Memorial Item',
  contact_category_business_card: 'Business Card',
  contact_category_accessory: 'Accessory',
  contact_category_architectural: 'Architectural Related',
  contact_category_other: 'Other',
  contact_success_message:
    'Your inquiry has been received. We will contact you within 24 hours.',
  contact_error_message: 'Failed to send. Please try again.',

  // Footer
  footer_company: 'NEXUTHA',
  footer_description:
    'Personal laser engraving workshop in Nagoya, Minato Ward. We carefully craft each piece with heart, engraving your thoughts into wood and stainless steel.',
  footer_quick_links: 'Quick Links',
  footer_links: 'Links',
  footer_services: 'Services',
  footer_contact_info: 'Contact Information',
  footer_made_with: 'Made with NEXUTHA',
  footer_copyright: '© 2026 NEXUTHA. All rights reserved.',
  footer_service_nameplate: 'Memorial Plates',
  footer_service_stainless: 'Stainless Steel Business Cards',
  footer_service_business_card: 'Wooden Nameplates',
  footer_service_memorial: 'Leather Keychains',
  footer_service_accessory: 'Acrylic Keychains (Black Limited)',
  footer_service_architectural: 'Custom Orders',
  footer_online_only: 'Online Only',
  footer_hours: '9:00-18:00 (Mon-Sat)',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Service',
  footer_commerce_law: 'Commercial Transaction Law',

  // Legal pages
  legal_privacy_hero_title: 'Privacy Policy',
  legal_privacy_hero_subtitle: 'NEXUTHA',
  legal_privacy_hero_desc: 'How we handle your personal information',
  legal_privacy_section1_title: '1. Definition of Personal Information',
  legal_privacy_section1_desc: '"Personal information" refers to information about a living individual\nthat can identify a specific person through the name, date of birth, address,\ntelephone number, email address, or other descriptions contained in the information.',
  legal_privacy_section2_title: '2. Collection and Use of Personal Information',
  legal_privacy_section2_desc: 'We collect and use personal information through appropriate means for the following purposes:',
  legal_privacy_purpose1: 'Responding to customer inquiries',
  legal_privacy_purpose2: 'Production, shipping, and after-sales service of ordered products',
  legal_privacy_purpose3: 'Preparation of estimates and related communications',
  legal_privacy_purpose4: 'Delivery of newsletters (only to customers who have opted in)',
  legal_privacy_purpose5: 'Quality improvement and statistical analysis of our services',
  legal_privacy_section3_title: '3. Management of Personal Information',
  legal_privacy_section3_desc: 'We maintain customer personal information in an accurate and up-to-date state.\nWe strive for its secure management by maintaining and managing security systems.\nWe also thoroughly educate employees to prevent unauthorized access, loss, damage, falsification, and leakage.',
  legal_privacy_section4_title: '4. Provision to Third Parties',
  legal_privacy_section4_desc: 'We will not provide personal information to third parties without customer consent, except in the following cases:',
  legal_privacy_provide1: 'When required by law',
  legal_privacy_provide2: 'When necessary to protect human life, body, or property',
  legal_privacy_provide3: 'When particularly necessary for the improvement of public health or the promotion of healthy child development',
  legal_privacy_provide4: 'When cooperating with national or local government agencies in the performance of their legally prescribed duties',
  legal_privacy_section5_title: '5. Use of Cookies',
  legal_privacy_section5_desc: 'Our website may use cookies to improve site convenience and analyze usage.\nCookies do not contain personally identifiable information.\nYou can disable cookies through your browser settings.',
  legal_privacy_section6_title: '6. Access Analysis Tools',
  legal_privacy_section6_desc: 'This site uses Google Analytics for service improvement.\nGoogle Analytics collects access information without identifying individuals using cookies.',
  legal_privacy_section7_title: '7. Contact Information',
  legal_privacy_section7_desc: 'For inquiries regarding the handling of personal information, please contact:',
  legal_privacy_contact_email: 'nexutha.official@gmail.com',
  legal_privacy_contact_hours: 'Reception hours: 9:00-18:00 (Mon-Sat)',
  legal_privacy_last_updated: 'Last updated: May 1, 2026',

  legal_terms_hero_title: 'Terms of Service',
  legal_terms_hero_subtitle: 'NEXUTHA',
  legal_terms_hero_desc: 'Rules for using our services',
  legal_terms_section1_title: 'Article 1 (Application)',
  legal_terms_section1_desc: 'These terms set forth the conditions for using the laser engraving services\n(hereinafter "the Service") provided by NEXUTHA (hereinafter "the Company").\nBy using the Service, the customer is deemed to have agreed to these terms.',
  legal_terms_section2_title: 'Article 2 (Orders and Contracts)',
  legal_terms_section2_desc: 'When a customer places an order for a product through the Service,\nwe will send an order confirmation email after reviewing the order details.\nThe contract is established upon sending the order confirmation email.',
  legal_terms_section3_title: 'Article 3 (Payment Method)',
  legal_terms_section3_desc: 'Payment is by bank transfer only. Production begins after payment confirmation. Transfer fees are the responsibility of the customer.',
  legal_terms_section4_title: 'Article 4 (Delivery and Shipping)',
  legal_terms_section4_desc: 'Items are shipped via Yamato Transport.\nThe Company is not liable for damage or loss during shipping,\nunless due to reasons attributable to the Company.',
  legal_terms_section5_title: 'Article 5 (Cancellation and Returns)',
  legal_terms_section5_desc: 'Cancellation before production begins is free of charge.\nAfter production begins, cancellation fees may apply depending on progress.\nReturns or exchanges due to customer circumstances are generally not accepted,\nunless the product has obvious defects.',
  legal_terms_section6_title: 'Article 6 (Copyright and Ownership)',
  legal_terms_section6_desc: 'Copyright of designs and data provided by the customer belongs to the customer.\nHowever, copyright of original designs created by the Company during production belongs to the Company.',
  legal_terms_section7_title: 'Article 7 (Prohibited Acts)',
  legal_terms_section7_desc: 'Customers must not engage in the following acts when using the Service:',
  legal_terms_prohibit1: 'Acts that violate laws or public order and morals',
  legal_terms_prohibit2: 'Acts that infringe upon the rights of other customers or third parties',
  legal_terms_prohibit3: 'Acts that interfere with the operation of the Service',
  legal_terms_prohibit4: 'Unauthorized access or attempts thereof',
  legal_terms_section8_title: 'Article 8 (Disclaimer)',
  legal_terms_section8_desc: 'The Company shall not be liable for any damages\nsuffered by the customer or third parties in connection with the Service,\nexcept in cases of willful misconduct or gross negligence by the Company.',
  legal_terms_section9_title: 'Article 9 (Changes to Terms)',
  legal_terms_section9_desc: 'The Company may change these terms without notice to customers when deemed necessary.\nThe revised terms take effect from the time they are posted on the Company website.',
  legal_terms_section10_title: 'Article 10 (Governing Law and Jurisdiction)',
  legal_terms_section10_desc: 'These terms shall be governed by the laws of Japan.\nIn the event of a dispute regarding the Service,\nthe Nagoya District Court shall be the exclusive court of first instance.',
  legal_terms_last_updated: 'Last updated: May 1, 2026',

  legal_commerce_hero_title: 'Commercial Transaction Law Disclosure',
  legal_commerce_hero_subtitle: 'NEXUTHA',
  legal_commerce_hero_desc: 'Business information and transaction conditions under the Commercial Transaction Law',
  legal_commerce_section1_title: 'Business Operator',
  legal_commerce_section1_desc: 'NEXUTHA (Nexus)',
  legal_commerce_section2_title: 'Representative',
  legal_commerce_section2_desc: 'Yasuhide Yamashita',
  legal_commerce_section3_title: 'Address',
  legal_commerce_section3_desc: 'Minato Ward, Nagoya City, Aichi Prefecture',
  legal_commerce_section4_title: 'Contact',
  legal_commerce_section4_desc: 'Email: nexutha.official@gmail.com\nPhone: 080-2668-1795 (Reception: 9:00-18:00, Mon-Sat)',
  legal_commerce_section5_title: 'Sales Price',
  legal_commerce_section5_desc: 'Prices are based on those listed on each product page.\nConsumption tax is included in the price (tax-inclusive display).',
  legal_commerce_section6_title: 'Payment Method',
  legal_commerce_section6_desc: 'Bank transfer (transfer fees are the responsibility of the customer)',
  legal_commerce_section7_title: 'Product Delivery Time',
  legal_commerce_section7_desc: 'After payment confirmation, production and shipping are typically completed within 5-7 business days.\nExpress delivery is available within 3 business days (+\u00A52,000).',
  legal_commerce_section8_title: 'Returns and Cancellations',
  legal_commerce_section8_desc: 'Cancellation before production begins is free of charge.\nAfter production begins, cancellation fees may apply depending on progress.\nReturns due to customer circumstances are not accepted.',
  legal_commerce_section9_title: 'Shipping Method and Fees',
  legal_commerce_section9_desc: 'Shipped via Yamato Transport.\nShipping fees vary by destination and will be provided at the time of quotation.',
  legal_commerce_section10_title: 'Operating Environment',
  legal_commerce_section10_desc: 'This website is compatible with the latest versions of the following browsers:\nGoogle Chrome / Safari / Firefox / Microsoft Edge',
  legal_commerce_last_updated: 'Last updated: May 1, 2026',
  legal_commerce_section11_title: 'Corporate Orders',
  legal_commerce_section11_desc: 'We also accept orders from corporations.\nPlease feel free to contact us, just like individual customers.\nWritten estimates can also be issued.',
  legal_commerce_section12_title: 'Qualified Invoice System (Invoice)',
  legal_commerce_section12_desc: 'We are not currently registered as a Qualified Invoice Issuing Business\nunder the Qualified Invoice System.\nIf invoice support is required, please contact us separately.\nIf it is not an issue, please place your order with that understanding.',

  // Products Page
  products_coming_soon_badge: 'Coming Soon — Updated Regularly',
  products_hero_title: 'Products',
  products_hero_desc: 'Currently preparing our product listings. Items will be added as they become available.',
  products_preparing_title: 'Preparing Products',
  products_preparing_desc: 'We are currently preparing our product listings. Items will be posted here once completed. If you have any requests or questions, please feel free to contact us via LINE or the inquiry form.',
  products_line_cta: 'Inquire via LINE',
  products_notice_title: 'Products page is currently being prepared',
  products_notice_desc: 'New items are added and updated regularly. For any requests or questions, please contact us via LINE or the inquiry form.',
  products_view_detail: 'View Details',
  products_inquiry_btn: 'Inquire',
  products_soldout: 'Sold Out',
  products_price_range: 'Price Range',
  products_price_note: '* Please contact us for details',
  products_line_inquiry: 'Inquire via LINE',
  products_empty: 'No products found',
  products_inquiry_badge: 'Contact',
  products_inquiry_title: 'Feel free to ask about any item',
  products_inquiry_desc: 'Send us a message like "I saw your listings. Is this item available?" We welcome image sharing via LINE too.',
  products_inquiry_line_title: 'LINE Official Account',
  products_inquiry_line_desc: 'Image sharing & quick response',
  products_inquiry_form_title: 'Inquiry Form',
  products_inquiry_form_desc: '24/7 reception, next business day reply',
  products_inquiry_modal_badge: 'Inquiry',
  products_inquiry_modal_title: 'Product Inquiry',
  products_inquiry_modal_product: 'Product',
  products_inquiry_name: 'Name',
  products_inquiry_name_placeholder: 'John Doe',
  products_inquiry_email: 'Email Address',
  products_inquiry_message: 'Message',
  products_inquiry_message_placeholder: 'e.g. I saw your listings. Is the Stainless Steel Business Card (Standard) currently available? I am interested in about 50 pieces.',
  products_inquiry_submit: 'Send',
  products_inquiry_submitting: 'Sending...',
  products_inquiry_error: 'Failed to send. Please try again.',
  products_inquiry_privacy_note: 'Your information will only be used for production and replies.',
  products_inquiry_success_title: 'Inquiry received',
  products_inquiry_success_desc: 'We will contact you within 24 hours. For urgent inquiries, please also reach us via LINE.',

  // Gallery Page
  gallery_badge_text: 'Works Gallery',
  gallery_title: 'Portfolio Gallery',
  gallery_description:
    'Explore our diverse collection of laser-engraved works. Discover the beautiful creations born from the fusion of laser engraving technology and creativity.',
  gallery_upload_button: 'Upload Images',
  gallery_uploading: 'Uploading',
  gallery_uploading_progress: 'Processing files...',
  gallery_supported_formats: 'JPG, PNG supported',
  gallery_max_size: 'Max 10MB',
  gallery_multiple_support: 'Multiple selection',
  gallery_file_size_error:
    'File "{{fileName}}" is too large (max 10MB)',
  gallery_file_type_error:
    'File "{{fileName}}" is not an image file',
  gallery_uploaded_work_description: 'Uploaded work',
  gallery_material_digital: 'Digital',
  gallery_technique_upload: 'Upload',
  gallery_delete_confirmation:
    'Are you sure you want to delete this image?',
  gallery_download_failed: 'Download failed',
  gallery_filter_all: 'All',
  gallery_filter_plates: 'Plates',
  gallery_filter_cards: 'Cards',
  gallery_filter_accessories: 'Accessories',
  gallery_filter_custom: 'Custom',
  gallery_search_placeholder: 'Search works...',
  gallery_sort_date: 'By Date',
  gallery_sort_title: 'By Title',
  gallery_sort_category: 'By Category',
  gallery_stats_total_works: 'Total Works',
  gallery_stats_my_works: 'My Works',
  gallery_stats_displaying: 'Displaying',
  gallery_stats_categories: 'Categories',
  gallery_stats_featured: 'Featured',
  gallery_my_work_badge: 'My Work',
  gallery_featured_work: 'Featured',
  gallery_category_custom: 'Custom',
  gallery_no_photos_title: 'No Works Available',
  gallery_no_photos_description:
    'No works have been uploaded yet. Please add works through the admin panel.',
  gallery_download: 'Download',
  gallery_delete: 'Delete',
  gallery_detail_material: 'Material',
  gallery_detail_size: 'Size',
  gallery_detail_technique: 'Technique',
  gallery_upload_date: 'Upload Date',
  gallery_admin_access: 'Admin Panel',
  gallery_view_only: 'View Only',
  gallery_download_available: 'Download Available',
  gallery_search_filter: 'Search & Filter',

  // Admin translations
  admin_login_title: 'Admin Login',
  admin_login_description: 'Password required for gallery management',
  admin_password_label: 'Password',
  admin_password_placeholder: 'Enter password',
  admin_login_button: 'Login',
  admin_back_to_gallery: 'Back to Gallery',
  admin_invalid_password: 'Invalid password',
  admin_panel_badge: 'Admin Panel',
  admin_panel_title: 'Gallery Management',
  admin_panel_description: 'Upload, edit, and delete works',
  admin_view_gallery: 'View Gallery',
  admin_logout: 'Logout',
  admin_upload_section_title: 'Upload New Works',
  admin_upload_title: 'Select Files',
  admin_upload_description:
    'Upload JPG, PNG image files (max 10MB)',
  admin_select_files: 'Select Files',
  admin_total_photos: 'Total Works',
  admin_today_uploads: "Today's Uploads",
  admin_total_size: 'Total Size',
  admin_manage_photos: 'Manage Works',
  admin_no_photos: 'No works yet',
  admin_view_details: 'View Details',
  admin_edit: 'Edit',
  admin_delete: 'Delete',
  admin_upload_date: 'Upload Date',
  admin_category: 'Category',
  admin_size: 'Size',
  admin_material: 'Material',
  admin_edit_photo: 'Edit Work',
  admin_photo_title: 'Title',
  admin_photo_description: 'Description',
  admin_photo_category: 'Category',
  admin_photo_material: 'Material',
  admin_photo_technique: 'Technique',
  admin_cancel: 'Cancel',
  admin_save_changes: 'Save Changes',
  admin_supported_formats: 'JPG, PNG supported',
  admin_max_size: 'Max 10MB',
  admin_multiple_support: 'Multiple selection',

  // Testimonials Page
  testimonials_title: 'Customer Testimonials',
  testimonials_subtitle: 'Hear from our satisfied customers',
  testimonials_badge_text: 'Customer Reviews',
  testimonials_like_button: 'Like',
  testimonials_already_liked: 'Already liked',
  testimonials_nexutha_reply: 'Reply from NEXUTHA',

  // Testimonials stats
  testimonials_stats_title: 'Customer Satisfaction',
  testimonials_total_reviews: 'Total Reviews',
  testimonials_average_rating: 'Average Rating',
  testimonials_satisfaction_rate: 'Satisfaction Rate',
  testimonials_repeat_customers: 'Repeat Rate',

  // Customer testimonials (chronological order: January 2025 → January 2026)
  testimonials_customer_23_name: 'Mr. H.K.',
  testimonials_customer_23_age: '40s',
  testimonials_customer_23_gender: 'Male',
  testimonials_customer_23_location: 'Aichi Prefecture',
  testimonials_customer_23_product: 'Stainless Steel Glass Laser Engraving (100 pcs)',
  testimonials_customer_23_comment: 'I ordered again in March. This time, about 100 stainless steel glasses were engraved with our company logo. I heard that engraving on cylindrical surfaces is difficult, but the finish was very clean and well-received by our staff. They always respond carefully, so I would like to order again next time.',
  testimonials_customer_23_date: '2026-03-18',
  testimonials_customer_23_reply: 'Mr. H.K., thank you for ordering again. Engraving logos on cylindrical surfaces requires careful adjustment each time, and the sense of accomplishment when it comes out beautifully is immense. We are very happy to hear that your staff was pleased as well. Please feel free to contact us anytime. (Yamashita)',

  testimonials_customer_22_name: 'Mr. M.T.',
  testimonials_customer_22_age: '30s',
  testimonials_customer_22_gender: 'Male',
  testimonials_customer_22_location: 'Aichi Prefecture',
  testimonials_customer_22_product: 'Original Keychains (Stainless Plate × 10 pcs)',
  testimonials_customer_22_comment: 'You helped me think through the design from the very beginning, and the result exceeded my expectations. The combination of stainless plate and keychain is simple yet solid. It was a great experience to see my idea take shape.',
  testimonials_customer_22_date: '2026-03-22',
  testimonials_customer_22_reply: 'Mr. M.T., it was a fun project working on the design together. Gradually shaping the "kind of vibe I want" into something real always brings new discoveries. We are glad you liked it. Please feel free to consult us again anytime. (Yamashita)',

  testimonials_customer_21_name: 'Mr. K.',
  testimonials_customer_21_age: '50s',
  testimonials_customer_21_gender: 'Male',
  testimonials_customer_21_location: 'Aichi Prefecture',
  testimonials_customer_21_product: 'Luxury Wooden Hanger Name Engraving',
  testimonials_customer_21_comment: 'I ordered an engraving on a wooden hanger as a gift, with the recipient\'s name and a design incorporating the stroke count. The recipient was very pleased, and I am glad I chose it as a gift. The elegant finish was satisfying.',
  testimonials_customer_21_date: '2026-03-28',
  testimonials_customer_21_reply: 'Mr. K., thank you for choosing us for your gift. Incorporating the stroke count into the design was a lot of fun to work on. We are so happy to hear the recipient was pleased as well. Please come back anytime. (Yamashita)',

  testimonials_customer_19_name: 'Mr. Oshima',
  testimonials_customer_19_age: '50s',
  testimonials_customer_19_gender: 'Male',
  testimonials_customer_19_location: 'Aichi Prefecture',
  testimonials_customer_19_product:
    'Custom Nameplate for Bank Executive',
  testimonials_customer_19_comment:
    "I initially wanted to engrave on a fountain pen, but Mr. Hasegawa pointed out the risk of damaging such an expensive item, so I decided to hold off. Later, he proposed a nameplate as an alternative, and to be honest, I had almost given up, but the result exceeded my expectations. I'm very satisfied. Thank you for your professional service.",
  testimonials_customer_19_date: '2026-01-06',
  testimonials_customer_19_reply:
    "Mr. Oshima, thank you for entrusting us with your custom order. Although we initially decided to hold off, I thought about how to protect your valuable item while fulfilling your request, and proposed a nameplate. When you said you had \"almost given up,\" I was truly glad I made the proposal. We look forward to serving you again in the future. (Hasegawa)",

  testimonials_customer_18_name: 'Mr. Ikeda',
  testimonials_customer_18_age: '20s',
  testimonials_customer_18_gender: 'Male',
  testimonials_customer_18_location: 'Ibaraki Prefecture',
  testimonials_customer_18_product: 'Job Offer Memorial Plate',
  testimonials_customer_18_comment:
    'I had this made to commemorate receiving a job offer from my first-choice company. With the company name and offer date engraved, it has renewed my determination as a new member of society.',
  testimonials_customer_18_date: '2025-01-08',
  testimonials_customer_18_reply:
    'Mr. Ikeda, congratulations on your job offer! We are honored to have created a plate to commemorate the start of a new chapter in your life. We sincerely wish you great success as a new member of society. (Yamashita)',

  testimonials_customer_17_name: 'Ms. Mori',
  testimonials_customer_17_age: '30s',
  testimonials_customer_17_gender: 'Female',
  testimonials_customer_17_location: 'Tochigi Prefecture',
  testimonials_customer_17_product: 'Theater Performance Memorial Plate',
  testimonials_customer_17_comment: 'I had this made as a commemorative piece for our theater performance. The work title and performance date are beautifully engraved, and all the troupe members are delighted.',
  testimonials_customer_17_date: '2025-01-25',
  testimonials_customer_17_reply: 'Ms. Mori, congratulations on the success of your performance. We are truly happy that all the troupe members are pleased. As a craftsman, I am proud to have given shape to your passion for theater. (Hasegawa)',

  testimonials_customer_16_name: 'Mr. Shimizu',
  testimonials_customer_16_age: '50s',
  testimonials_customer_16_gender: 'Male',
  testimonials_customer_16_location: 'Gunma Prefecture',
  testimonials_customer_16_product: 'Darts Tournament Championship Memorial Plate',
  testimonials_customer_16_comment: 'I had this made to commemorate winning a darts tournament. The tournament name and winning date are engraved, and I display it proudly at home.',
  testimonials_customer_16_date: '2025-02-18',
  testimonials_customer_16_reply: 'Mr. Shimizu, congratulations on your championship! We are honored to have helped give shape to the fruits of your hard work. We look forward to hearing about your future tournament successes. (Yamashita)',

  testimonials_customer_15_name: 'Ms. Saito',
  testimonials_customer_15_age: '40s',
  testimonials_customer_15_gender: 'Female',
  testimonials_customer_15_location: 'Niigata Prefecture',
  testimonials_customer_15_product: 'Cherry Blossom Festival Memorial Plate',
  testimonials_customer_15_comment: 'I had this made as a commemorative piece for our local cherry blossom festival. The festival name and year are beautifully engraved, and I look forward to next year too.',
  testimonials_customer_15_date: '2025-03-10',
  testimonials_customer_15_reply: 'Ms. Saito, thank you for choosing us for your community event commemorative item. We hope the cherry blossom festival continues to create wonderful memories every year. (Hasegawa)',

  testimonials_customer_14_name: 'Mr. Hayashi',
  testimonials_customer_14_age: '30s',
  testimonials_customer_14_gender: 'Male',
  testimonials_customer_14_location: 'Ishikawa Prefecture',
  testimonials_customer_14_product: 'Circus Troupe Performance Memorial Plate',
  testimonials_customer_14_comment: 'I had this made to commemorate the success of our circus troupe\'s performance. The troupe name and performance date are engraved, and all the members treasure it.',
  testimonials_customer_14_date: '2025-04-22',
  testimonials_customer_14_reply: 'Mr. Hayashi, congratulations on the success of your circus performance! We are truly happy to have given shape to the unity and effort of all the troupe members. Keep up the amazing performances! (Yamashita)',

  testimonials_customer_13_name: 'Ms. Kimura',
  testimonials_customer_13_age: '20s',
  testimonials_customer_13_gender: 'Female',
  testimonials_customer_13_location: 'Okayama Prefecture',
  testimonials_customer_13_product: 'Library Certification Memorial Plate',
  testimonials_customer_13_comment: 'I had this made to commemorate obtaining my library certification. The certification name and date are beautifully engraved, and I am very satisfied.',
  testimonials_customer_13_date: '2025-05-15',
  testimonials_customer_13_reply: 'Ms. Kimura, congratulations on obtaining your certification! We are honored to have helped give shape to the results of your hard work. We sincerely support your success as a librarian. (Hasegawa)',

  testimonials_customer_12_name: 'Ms. Inoue',
  testimonials_customer_12_age: '60s',
  testimonials_customer_12_gender: 'Female',
  testimonials_customer_12_location: 'Okinawa Prefecture',
  testimonials_customer_12_product: 'New Home Celebration Plate',
  testimonials_customer_12_comment: 'I had the family name and the date of moving in engraved to commemorate our new home. It is displayed in the entrance and has been well-received by visitors.',
  testimonials_customer_12_date: '2025-06-28',
  testimonials_customer_12_reply: 'Ms. Inoue, congratulations on your new home! We are truly happy to have created a plate to commemorate your family\'s new beginning. We wish you many happy days in your new home. (Yamashita)',

  testimonials_customer_11_name: 'Mr. Matsumoto',
  testimonials_customer_11_age: '40s',
  testimonials_customer_11_gender: 'Male',
  testimonials_customer_11_location: 'Nagano Prefecture',
  testimonials_customer_11_product: 'Car Purchase Memorial Plate',
  testimonials_customer_11_comment: 'I had this made to commemorate the purchase of my long-awaited car. The car model and purchase date are engraved, and I display it in my garage.',
  testimonials_customer_11_date: '2025-07-18',
  testimonials_customer_11_reply: 'Mr. Matsumoto, congratulations on your long-awaited car purchase! Please enjoy wonderful drives with your beloved car. (Hasegawa)',

  testimonials_customer_10_name: 'Ms. Kato',
  testimonials_customer_10_age: '50s',
  testimonials_customer_10_gender: 'Female',
  testimonials_customer_10_location: 'Kyoto Prefecture',
  testimonials_customer_10_product: 'Cafe Opening Memorial Plate',
  testimonials_customer_10_comment: 'I had the cafe name and opening date engraved to commemorate the opening of my cafe. It is displayed at the entrance and customers often say "How lovely!"',
  testimonials_customer_10_date: '2025-07-30',
  testimonials_customer_10_reply: 'Ms. Kato, congratulations on the opening of your cafe! We are very happy to hear that customers are also pleased with it. We wish your cafe continued success. (Yamashita)',

  testimonials_customer_9_name: 'Ms. Kobayashi',
  testimonials_customer_9_age: '30s',
  testimonials_customer_9_gender: 'Female',
  testimonials_customer_9_location: 'Hiroshima Prefecture',
  testimonials_customer_9_product: 'Music Recital Memorial Plate',
  testimonials_customer_9_comment: 'I had this made to commemorate my daughter\'s piano recital. The piece name and date are beautifully engraved, and my daughter is very pleased.',
  testimonials_customer_9_date: '2025-08-12',
  testimonials_customer_9_reply: 'Ms. Kobayashi, congratulations on your daughter\'s successful recital. We are honored that she is pleased with the plate that gives shape to her musical passion. Keep up the wonderful playing! (Hasegawa)',

  testimonials_customer_8_name: 'Mr. Nakamura',
  testimonials_customer_8_age: '20s',
  testimonials_customer_8_gender: 'Male',
  testimonials_customer_8_location: 'Shizuoka Prefecture',
  testimonials_customer_8_product: 'Soccer Team Championship Memorial Plate',
  testimonials_customer_8_comment: 'I had this made to commemorate our soccer team\'s championship. The team name and championship year are engraved, and all the team members treasure it.',
  testimonials_customer_8_date: '2025-08-25',
  testimonials_customer_8_reply: 'Mr. Nakamura, congratulations on your championship! We are truly happy to have given shape to the unity and effort of all the team members. We look forward to your future success in competitions! (Yamashita)',

  testimonials_customer_7_name: 'Ms. Watanabe',
  testimonials_customer_7_age: '40s',
  testimonials_customer_7_gender: 'Female',
  testimonials_customer_7_location: 'Miyagi Prefecture',
  testimonials_customer_7_product: 'Custom Business Card',
  testimonials_customer_7_comment: 'As a designer, I wanted a unique business card and placed an order. My original design was beautifully engraved, and the response from clients has been excellent.',
  testimonials_customer_7_date: '2025-09-10',
  testimonials_customer_7_reply: 'Ms. Watanabe, we are very happy to hear that your clients are also pleased with it. We sincerely support your success as a designer! (Hasegawa)',

  testimonials_customer_6_name: 'Mr. Ito',
  testimonials_customer_6_age: '30s',
  testimonials_customer_6_gender: 'Male',
  testimonials_customer_6_location: 'Hokkaido',
  testimonials_customer_6_product: 'Company Founding Memorial Plate',
  testimonials_customer_6_comment: 'I had the company name and founding date engraved to commemorate starting my business. It is displayed at the office reception and has been well-received by visitors.',
  testimonials_customer_6_date: '2025-09-22',
  testimonials_customer_6_reply: 'Mr. Ito, congratulations on starting your business! We are honored to have created a plate to commemorate the beginning of your company. We wish your business continued growth and success. (Yamashita)',

  testimonials_customer_5_name: 'Mr. Takahashi',
  testimonials_customer_5_age: '60s',
  testimonials_customer_5_gender: 'Male',
  testimonials_customer_5_location: 'Fukuoka Prefecture',
  testimonials_customer_5_product: '60th Birthday Celebration Plate',
  testimonials_customer_5_comment: 'My family gave this to me as a gift for my 60th birthday. My name and date of birth are beautifully engraved, and I was deeply moved.',
  testimonials_customer_5_date: '2025-10-03',
  testimonials_customer_5_reply: 'Mr. Takahashi, happy 60th birthday! We are very happy to have helped give shape to the love-filled gift from your family. Please continue to stay healthy. (Hasegawa)',

  testimonials_customer_4_name: 'Ms. Suzuki',
  testimonials_customer_4_age: '50s',
  testimonials_customer_4_gender: 'Female',
  testimonials_customer_4_location: 'Kanagawa Prefecture',
  testimonials_customer_4_product: 'Retirement Memorial Plate',
  testimonials_customer_4_comment: 'I ordered this as a commemorative item when retiring from the company I had worked at for many years. My colleagues also said "How lovely!", and I am very satisfied.',
  testimonials_customer_4_date: '2025-10-15',
  testimonials_customer_4_reply: 'Ms. Suzuki, thank you for your many years of hard work. We are honored to have created a plate to commemorate this important milestone in your life. We wish you great success in your new chapter. (Yamashita)',

  testimonials_customer_3_name: 'Mr. Yamada',
  testimonials_customer_3_age: '20s',
  testimonials_customer_3_gender: 'Male',
  testimonials_customer_3_location: 'Aichi Prefecture',
  testimonials_customer_3_product: 'University Acceptance Memorial Plate',
  testimonials_customer_3_comment: 'I had this made to commemorate my son\'s university acceptance. The university name and acceptance date are beautifully engraved, and the whole family is delighted.',
  testimonials_customer_3_date: '2025-10-28',
  testimonials_customer_3_reply: 'Mr. Yamada, congratulations on your son\'s university acceptance! We are truly happy as craftsmen to have given shape to your family\'s joy. We sincerely wish your son great success in the future. (Hasegawa)',

  testimonials_customer_2_name: 'Mr. Sato',
  testimonials_customer_2_age: '40s',
  testimonials_customer_2_gender: 'Male',
  testimonials_customer_2_location: 'Osaka Prefecture',
  testimonials_customer_2_product: 'Stainless Steel Business Card',
  testimonials_customer_2_comment: 'I ordered this as a sales professional wanting to differentiate myself from other companies. It always becomes a topic of conversation in client meetings, and I leave a lasting impression. It was worth more than the investment.',
  testimonials_customer_2_date: '2025-11-08',
  testimonials_customer_2_reply: 'Mr. Sato, we are very happy to hear that it is useful in your sales activities. We are honored to have contributed to making an impression in business settings. We continue to support your success! (Yamashita)',

  testimonials_customer_1_name: 'Ms. Tanaka',
  testimonials_customer_1_age: '30s',
  testimonials_customer_1_gender: 'Female',
  testimonials_customer_1_location: 'Tokyo',
  testimonials_customer_1_product: 'Wedding Anniversary Memorial Plate',
  testimonials_customer_1_comment: 'I had our names and anniversary date engraved to commemorate our 10th wedding anniversary. The stainless steel texture has a luxurious feel, and it is displayed in our living room. It has become a lifelong treasure.',
  testimonials_customer_1_date: '2025-11-15',
  testimonials_customer_1_reply: 'Ms. Tanaka, congratulations on your 10th wedding anniversary. We are truly happy to have helped give shape to your precious anniversary. May you both continue to be happy together. (Hasegawa)',

  // FAQ Page
  faq_title: 'Frequently Asked Questions',
  faq_subtitle: 'Answers to common questions from customers',
  faq_category_pricing: 'About Pricing',
  faq_category_delivery: 'About Delivery & Shipping',
  faq_category_design: 'About Design',
  faq_category_materials: 'About Materials',
  faq_category_other: 'Other',

  // Process Page
  process_page_title: 'Our Process',
  process_page_subtitle: 'Realize your ideal work in 5 steps',
  process_quality_title: 'Commitment to Quality',
  process_quality_subtitle: 'Uncompromising quality control',
  process_express_title: 'Express Service',
  process_express_subtitle: 'Reliable service for urgent needs',

  // Common
  free_consultation: 'Free Consultation',
  years: 'Years',
  projects_count: 'Projects',
  percent: '%',

  // FAQ in Pricing
  faq_pricing_question_1: 'How much does it cost?',
  faq_pricing_answer_1:
    'Stainless steel business cards start at ¥500 per piece, and memorial plates start at ¥8,000. A 10% discount is applied for website orders.',
  faq_pricing_question_2: 'Is the quote free?',
  faq_pricing_answer_2:
    'Yes, quotes are completely free. Please feel free to contact us through the website quote form or by phone. We also prepare written estimates.',
  faq_pricing_question_3: 'What payment methods are available?',
  faq_pricing_answer_3: 'Payment is by bank transfer. Production will begin after payment confirmation.',
  faq_delivery_question_1: 'What is the delivery time?',
  faq_delivery_answer_1:
    'We typically deliver within 5-7 business days. Express delivery within 3 days is also available for urgent cases (+¥2,000).',
  faq_delivery_question_2: 'Are there shipping fees?',
  faq_delivery_answer_2:
    'We will check and provide the appropriate shipping cost based on your delivery destination. We will provide the total amount including shipping fees when quoting.',
  faq_design_question_1: 'Can I request design revisions?',
  faq_design_answer_1:
    'After the initial design proposal, up to 2 revisions are free. From the 3rd revision onwards, a fee of ¥1,000 per revision applies.',
  faq_more_questions:
    'For other questions, please visit the FAQ page',
  faq_view_all: 'View all questions',

  // Added missing comma before the next block
  // FAQ Page - full content
  faq_page_title: 'Laser Engraving FAQ | NEXUTHA Nagoya',
  faq_page_description:
    'Frequently asked questions about NEXUTHA laser engraving services. Pricing, delivery, design, materials and more.',
  faq_breadcrumb_home: 'Home',
  faq_breadcrumb_faq: 'FAQ',
  faq_hero_badge: 'FAQ',
  faq_hero_title: 'Laser Engraving FAQ',
  faq_hero_subtitle: 'NEXUTHA Nagoya',
  faq_hero_description: 'Answers to common questions from our customers',
  faq_contact_box_title: 'Need Help?',
  faq_contact_box_desc:
    'If you have any questions not listed here, please feel free to contact us.',
  faq_contact_button: 'Contact Us',
  faq_estimate_button: 'Request Quote',
  faq_notice_title: 'Notice for Visitors',
  faq_notice_subtitle: 'For those considering drop-off engraving',
  faq_notice_intro1:
    'NEXUTHA is a small private workshop in Minato Ward, Nagoya, where each piece is crafted by hand. While our setup differs from large factories, we pride ourselves on meticulous craftsmanship.',
  faq_notice_intro2:
    'We do accept drop-off items for engraving, but please note the following before visiting.',
  faq_notice_parking_title: 'Parking',
  faq_notice_parking_desc:
    'We do not have a dedicated parking lot. Please use a nearby coin parking lot or briefly stop in front of the workshop.',
  faq_notice_road_title: 'Workshop Surroundings',
  faq_notice_road_desc:
    'The road in front of the workshop is relatively wide (approximately one lane each way), but long-term parking may inconvenience neighbors. Short stops for item drop-off/pickup are fine.',
  faq_notice_reservation_title: 'Appointment Required',
  faq_notice_reservation_desc:
    'As a small workshop focused on production, we cannot accommodate walk-in visits. Please contact us via LINE or the inquiry form before visiting.',
  faq_notice_footer: 'Thank you for your understanding and cooperation.',
  faq_cta_title: 'Still have questions?',
  faq_cta_desc:
    'Feel free to contact us. Our specialists will answer your questions carefully.',
  faq_cta_contact: 'Contact Us',
  faq_cta_estimate: 'Request Quote',

  faq_cat_pricing: 'Pricing',
  faq_cat_delivery: 'Delivery & Shipping',
  faq_cat_design: 'Design & Production',
  faq_cat_materials: 'Materials & Specs',
  faq_cat_other: 'Other',

  faq_q_price: 'How much does it cost?',
  faq_a_price:
    'Stainless steel business cards start at ¥500 per piece, and memorial plates start at ¥3,000. A 10% discount applies for website orders. Use our price simulator for detailed estimates.',
  faq_q_quote_free: 'Is the quote free?',
  faq_a_quote_free:
    'Yes, quotes are completely free. Please contact us via the website form or by phone. Written estimates are also available.',
  faq_q_payment: 'What payment methods are available?',
  faq_a_payment: 'Payment is by bank transfer. Production begins after payment confirmation.',
  faq_q_cancel: 'Is there a cancellation fee?',
  faq_a_cancel:
    'Cancellation before production starts is free. After production begins, a cancellation fee may apply depending on progress.',
  faq_q_delivery_time: 'What is the delivery time?',
  faq_a_delivery_time:
    'Typically 5–7 business days. Express delivery within 3 days is available for urgent orders (+¥2,000).',
  faq_q_shipping_fee: 'Are there shipping fees?',
  faq_a_shipping_fee:
    'Shipping costs vary by destination. We will provide the total including shipping when quoting.',
  faq_q_shipping_method: 'Can I choose the shipping method?',
  faq_a_shipping_method:
    'We ship via Yamato Transport. Time-specific delivery is available. Items are handled with care as valuables.',
  faq_q_overseas: 'Do you ship overseas?',
  faq_a_overseas: 'We currently only ship within Japan.',
  faq_q_revision: 'Can I request design revisions?',
  faq_a_revision:
    'Up to 2 revisions are free after the initial design proposal. From the 3rd revision, a fee of ¥1,000 per revision applies.',
  faq_q_any_design: 'Can you handle any design?',
  faq_a_any_design:
    'We can handle photos, logos, text, illustrations, and more. However, designs involving copyright issues cannot be accepted.',
  faq_q_file_format: 'What file formats do you accept?',
  faq_a_file_format:
    'We accept AI, EPS, PDF, JPEG, and more. We can also create designs from hand-drawn sketches.',
  faq_q_text_size: 'Is there a minimum text size?',
  faq_a_text_size:
    'We can engrave down to approximately 1mm, but recommend 2mm or larger for readability.',
  faq_q_material: 'What materials do you use?',
  faq_a_material:
    'We use high-quality stainless steel (SUS304), which is rust-resistant and maintains its beauty for a long time.',
  faq_q_size_limit: 'Is there a size limit?',
  faq_a_size_limit:
    'Maximum size is 22cm × 22cm. Thickness is typically 1–2mm.',
  faq_q_color: 'Can you add color?',
  faq_a_color:
    'We currently do not offer coloring. Items are provided in the natural stainless steel finish.',
  faq_q_durability: 'How durable are the products?',
  faq_a_durability:
    'Stainless steel products are virtually permanent. Under normal use, there is almost no discoloration or deterioration.',
  faq_q_sample: 'Can I see a sample before ordering?',
  faq_a_sample:
    'We do not mail samples, but you can view past work in our gallery.',
  faq_q_corporate: 'Do you accept corporate orders?',
  faq_a_corporate:
    'Yes, we also accept orders from corporations. Please feel free to contact us, just like individual customers. Written estimates can also be issued.',
  faq_q_after_service: 'Do you offer after-sales service?',
  faq_a_after_service:
    'In case of defects or damage, we offer free repair or replacement within 1 year of delivery.',
  faq_q_privacy: 'How is my personal information handled?',
  faq_a_privacy:
    'Customer information is strictly managed and not used for any purpose other than production. See our Privacy Policy for details.',
  faq_q_photos_limited: 'Why are there so few portfolio photos?',
  faq_a_photos_limited:
    'At NEXUTHA, we carefully engrave your precious memories one by one. Many of our works are original custom orders based on individual requests, and due to copyright and other considerations, we are unable to publish photos of all completed works. The images displayed include works from customers who have kindly agreed to share, along with reference images. We invite you to experience your very own special piece firsthand.',
  faq_q_bulk_order: 'Do you accept large quantity orders?',
  faq_a_bulk_order:
    'We do accept large orders depending on the circumstances. Please feel free to contact us for a consultation. We will provide the best proposal according to your delivery schedule and budget.',
  faq_q_wrapping: 'Do you offer gift wrapping?',
  faq_a_wrapping:
    'We currently do not offer wrapping services. Simple wrapping may be available upon consultation, so please feel free to inquire.',
  faq_q_extra_process: 'Can I request additional processes beyond engraving (painting, surface treatment, etc.)?',
  faq_a_extra_process:
    'We primarily handle design creation through laser engraving as an integrated service, and generally decline additional processes such as painting or surface treatment. However, depending on the details, we may take on the challenge, so please feel free to consult with us first.',

  // Studio / Workshop page
  // Studio name origin
  studio_name_origin_badge: 'Name Origin',
  studio_name_origin_title: 'What is NEXUTHA?',
  studio_name_origin_reading: 'Pronunciation: Nexus',
  studio_name_origin_desc: '"NEXUTHA (Nexus)" is a coined word combining\n**NEXT × US × ANSWER**.\n\n"We lead to the next answer" —\nStaying close to our customers\' wishes, we use AI and craftsmanship\nto open up new possibilities.\nThis intention is embedded in the name.',
  studio_name_origin_meaning1_title: 'NEXT',
  studio_name_origin_meaning1_desc: 'Always one step ahead of the times. Using AI × latest technology, we create new value beyond the boundaries of conventional workshops.',
  studio_name_origin_meaning2_title: 'US',
  studio_name_origin_meaning2_desc: 'Creating together with makers and receivers. We value the process of finding answers together with our customers.',
  studio_name_origin_meaning3_title: 'ANSWER',
  studio_name_origin_meaning3_desc: 'Delivering the best answer to our customers\' desire of "I want something like this." That is the mission of NEXUTHA.',

  studio_about_badge: 'About NEXUTHA',
  studio_hero_title: 'Workshop Introduction',
  studio_hero_subtitle: 'AI × Latest Technology — A Workshop Beyond the Ordinary',
  studio_hero_desc:
    'NEXUTHA is a completely new style workshop that fuses AI technology with cutting‑edge laser engraving.',
  studio_story_badge: 'Our Story',
  studio_story_title: 'AI × Latest Technology,',
  studio_story_title2: 'A Workshop Beyond the Ordinary',
  studio_story_p1:
    'NEXUTHA is a laser engraving workshop in Nagoya, operated by a husband-and-wife team. What sets us apart from other workshops is our active use of AI technology.',
  studio_story_p2:
    'From generating design images and selecting materials to calculating work hours — by leveraging AI expertise at every step, we achieve speed and precision that traditional workshops cannot match.',
  studio_story_p3:
    "Even customers who were initially hesitant about AI often say \"I didn't know it could do this!\" or \"Creating with AI is so fun!\" after experiencing it. Please try our new creative experience that fuses AI with the latest technology.",
  studio_stat_works: 'Works Completed',
  studio_stat_satisfaction: 'Customer Satisfaction',
  studio_stat_style: 'Unique Style',
  studio_ai_badge_title: 'AI × Latest Technology',
  studio_ai_badge_sub: 'Beyond Ordinary',
  studio_craftsmen_badge: 'Craftsmen',
  studio_craftsmen_title: 'Meet Our Craftsmen',
  studio_craftsmen_subtitle: 'Two creators who fuse AI with craftsmanship',
  studio_craftsman1_name: 'Yasuhide Yamashita',
  studio_craftsman1_role: 'Laser Engraving Craftsman / Designer',
  studio_craftsman1_bio:
    'Actively incorporating AI technology, he leverages specialized knowledge for design image generation, material selection, and work hour calculation. Combining Xtool F1 Ultra and Procreate, he creates one-of-a-kind works with precision and speed beyond conventional workshops.',
  studio_craftsman1_spec1: 'Laser Engraving',
  studio_craftsman1_spec2: 'AI Design',
  studio_craftsman1_spec3: 'Stainless Processing',
  studio_craftsman2_name: 'Ruwa Yamashita',
  studio_craftsman2_role: 'Laser Engraving Craftsman / Customer Support',
  studio_craftsman2_bio:
    'Valuing communication with customers, she uses AI-powered image proposals to accurately bring requests to life. She pours into each piece the new experience of making customers say "AI is amazing!"',
  studio_craftsman2_spec1: 'Metal Processing',
  studio_craftsman2_spec2: 'AI Proposals',
  studio_craftsman2_spec3: 'Quality Control',
  studio_values_badge: 'Our Values',
  studio_values_title: 'The NEXUTHA Commitment',
  studio_value1_title: 'AI × Craftsmanship',
  studio_value1_desc:
    'By incorporating AI for design generation, material proposals, and work hour calculation, we achieve precision and speed beyond conventional workshops.',
  studio_value2_title: 'New Creative Experience',
  studio_value2_desc:
    'A new process where customers expand their vision together with AI. We deliver the surprise and joy of "Can it really look like this?"',
  studio_value3_title: 'Uncompromising Precision',
  studio_value3_desc:
    'We are committed to precision down to 0.01mm, beautifully finishing the optimal design derived by AI.',
  studio_value4_title: 'Lasting Quality',
  studio_value4_desc:
    'Using high-quality materials including stainless steel, our works created with the latest technology maintain their beauty for years to come.',
  studio_equipment_badge: 'Equipment',
  studio_equipment_title: 'Tools & Equipment',
  studio_equipment_subtitle:
    'The tools that make exceptional results possible',
  studio_eq1_name: 'Xtool F1 Ultra',
  studio_eq1_category: 'Main Laser Machine',
  studio_eq1_desc:
    'A professional‑grade laser engraving machine with top‑class precision. Capable of processing down to 0.01mm, compatible with stainless steel, wood, acrylic, and more.',
  studio_eq1_spec1: 'Max Output: 20W',
  studio_eq1_spec2: 'Precision: 0.01mm',
  studio_eq1_spec3: 'Materials: Metal, Wood, Acrylic, Leather',
  studio_eq2_name: 'Procreate',
  studio_eq2_category: 'Design Tool',
  studio_eq2_desc:
    'A professional digital illustration app for iPad. We create original line art designs optimized for laser engraving from scratch, realizing unique designs for each customer.',
  studio_eq2_spec1: 'Original illustration creation',
  studio_eq2_spec2: 'Vector compatible',
  studio_eq2_spec3: 'Precise detailed design',
  studio_history_badge: 'History',
  studio_history_title: "NEXUTHA's Journey",
  studio_milestone1_year: '2023',
  studio_milestone1_event:
    'Started activities as NEXUTHA. Introduced Xtool F1 Ultra and began full-scale laser engraving.',
  studio_milestone2_year: '2024',
  studio_milestone2_event:
    'Surpassed 100 cumulative works. Stainless business cards and memorial plates spread by word of mouth, receiving orders from across Japan.',
  studio_milestone3_year: '2025',
  studio_milestone3_event:
    'Over 500 cumulative works. Achieved 98% customer satisfaction. Further expanded the range of custom orders.',
  studio_milestone4_year: '2026',
  studio_milestone4_event:
    'Started handling new materials such as brass and leather. Building a system to accommodate more diverse requests.',
  studio_cta_title: "Let's bring your vision to life together.",
  studio_cta_desc:
    'Consultations and quotes are free. Feel free to contact us.',
  studio_cta_consult: 'Free Consultation & Quote',
  studio_cta_gallery: 'View Our Works',

  // Gallery page hardcoded strings
  gallery_breadcrumb_home: 'Home',
  gallery_breadcrumb_gallery: 'Gallery',
  gallery_hero_title: 'Laser Engraving Gallery',
  gallery_hero_subtitle: 'NEXUTHA Nagoya',
  gallery_uploaded_work: 'Uploaded Work',
  gallery_sort_label: 'Sort',

  // Testimonials page hardcoded strings
  testimonials_breadcrumb_home: 'Home',
  testimonials_breadcrumb_page: 'Testimonials',
  testimonials_hero_title: 'Customer Reviews',
  testimonials_hero_subtitle2: 'NEXUTHA Laser Engraving',
  testimonials_customer_20_name: '(・∀・)',
  testimonials_customer_20_age: '30s',
  testimonials_customer_20_gender: 'Male',
  testimonials_customer_20_location: '',
  testimonials_customer_20_product: 'Brass Custom Pin · Skull Fish',
  testimonials_customer_20_comment:
    "I had the Skull Fish I fell in love with on social media customized into a highly practical pin badge.\n\nWhat surprised me when it arrived was the overwhelming sense of security. The joint on the back is carefully reinforced with resin, with absolutely no wobble. I feel the \"strength as a tool\" that can withstand hard use without compromising the design.\n\nFurthermore, the genuine leather keychain I received as a gift was beautifully polished to the edges, and I was moved by Mr. Yamashita's thorough craftsmanship. I will treasure it as a lifelong companion.",
  testimonials_customer_20_date: '2026-02-20',
  testimonials_customer_20_reply:
    "Thank you so much for placing the first custom order for NEXUTHA's inaugural work.\n\nIn this production, I prioritized durability in practical use while keeping the design beautiful. The joint on the back was filled with resin in 5 layers as reinforcement for the soldering, ensuring rigidity that won't budge even under finger pressure. It's not visible from the front, but it's the \"NEXUTHA standard\" finish for long-term use.\n\nI hope you enjoy the tough texture of brass and leather together with the leather keychain set. Please feel free to contact us anytime! (Yamashita)",

  nav_simulator: 'Simulator',

  // Header hardcoded strings
  nav_studio: 'Workshop',
  nav_blog: 'Blog',
  nav_column: 'Column',

  // PricingSection hardcoded strings
  pricing_simulator_heading: 'Price Simulator',
  pricing_product_select_label: 'Select Product Type',
  pricing_size_select_label: 'Select Size',
  pricing_quantity_select_label: 'Select Quantity',
  pricing_faq_badge: 'FAQ',
  pricing_faq_title: 'Frequently Asked Questions',
  pricing_faq_subtitle: 'Quick answers to pricing questions',
  pricing_size_namecard: 'Business Card Size (9cm×5.5cm)',
  pricing_qty_1: '1 piece',
  pricing_qty_5: '5 pieces',
  pricing_qty_10: '10 pieces',
  pricing_qty_20: '20 pieces',
  pricing_qty_50: '50 pieces',
  pricing_qty_100: '100 pieces',

  // Gallery download messages
  gallery_download_started: "Download started! Please check your device's download folder.",
  gallery_download_fallback: 'Direct download failed. The image has been opened in a new tab. Right-click and select "Save As" to save.',
  gallery_download_error: 'Download failed. The image data may be corrupted. Please contact the administrator.',
  gallery_copyright_notice: 'About Custom-Made Works',
  gallery_copyright_notice_desc: 'At NEXUTHA, we carefully engrave your precious memories one by one. Many of our works are original custom orders based on individual requests, and due to copyright and other considerations, we are unable to publish photos of all completed works. The images displayed include works from customers who have kindly agreed to share, along with reference images. We invite you to experience your very own special piece firsthand.',

  // AboutSection hardcoded strings
  about_satisfaction_label: 'Customer Satisfaction',

  // ContactSection hardcoded strings
  contact_line_badge: 'NEW',
  contact_line_title: 'Now on LINE Official Account!',
  contact_line_desc:
    'Easy image sharing! LINE is convenient for design consultations 📸',
  contact_line_add: 'Add Friend',

  // Footer hardcoded strings
  footer_line_label: 'LINE Official Account',

  // Common view all
  view_all_testimonials: 'View All Testimonials',
};
